<template>
 <div class="aboutUS">
   <div class="top">
     <img :src="$apiBaseUrl+top" style="width: 100%;height: 450px">
   </div>
   <h1 class="blue center Bt">联系我们</h1>
   <div class="center textF">以“专注、创新、共赢”为准则，为客户提供全方位的系统定制解决方案，把您的需求告诉我们，竭诚为您服务！</div>

   <div class="con_data content">
     <div class="address">
       <h3 class="Bt">河北八友台智能科技有限公司</h3>
       <p>联系地址：河北省石家庄市新石北路368号金石工业园区创新大厦605室</p>
       <p>联系电话：19567908984</p>
       <p>联系邮箱：byt19567908984@163.com</p>
       <p>邮编：050000</p>
     </div>
     <div class="maps">
       <div id="container" style="width:700px; height:500px;border: solid 1px #ddd"></div>
     </div>
   </div>

 </div>
</template>

<script>
import AMap from 'AMap' // 引入高德地图
export default {
  data(){
    return{
      top:''
    }
  },
  mounted() {
    this.addMarker();
    this.getTop()
  },
  methods: {
    addMarker() {
      let marker = new AMap.Marker({
        map:this.init(),
        position: [114.441434,38.018384]
      });
    },
    getTop() {
      let data = {params: {ImgCate: 10}}
      this.$axios.get('/api/Byt_Ent_Gateway/BytEntImgSelect', data).then(res => {
        res = typeof res.data == 'string' ? JSON.parse(res.data) : res.data;
        this.top = res.data[0].ImgPath;
      })
    },
    init() {
      return  new AMap.Map('container', {
        center: [114.441434,38.018384],
        resizeEnable: true,
        zoom: 10
      })
    }
  }
}
</script>

<style scoped>
  .content{
    display: flex;
    justify-content: space-between;
    font-size: 16px;
  }
  .textF{
    font-size: 18px;
  }
  .maps{
    width: 700px;height: 600px;
    padding: 50px 0;
    box-sizing: border-box;
  }

</style>